<template>
  <div class="cesta">
    <v-container>
      <v-row>
        <v-col>
          <v-breadcrumbs :items="items" :divider="'|'" class="py-0">
            <template v-slot:item="props">
              <v-breadcrumbs-item
                :href="props.item.href"
                :class="[props.item.disabled && 'disabled']"
              >
                <span
                  style="color: black;"
                  v-bind:class="{bold : props.item.text == 'Carrito de Compra'}"
                >{{ props.item.text }}</span>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center">
          <h1 class="PTSerif" style="font-size: 20px;">Wishlist</h1>
        </v-col>
      </v-row>

      <v-row class="pb-10" style="min-height: calc(100vh - (90px + 72px + 42px + 54px + 282px));">
        <v-col>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr id="table-carrito">
                  <th class="d-none d-md-table-cell"></th>
                  <th class="text-center text-md-left title-table">Producto</th>
                  <th class="text-center text-md-left title-table">Precio</th>
                  <th class="d-none d-md-table-cell"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,i) in productos" :key="i" height="77px">
                  <td class="py-2" style="position:relative;">
                    <v-img
                      :src="'https://flordeazaharcms.actstudio.xyz/'+item.cover.path"
                      width="56"
                      height="56"
                      class="d-block mx-auto mx-md-none"
                    ></v-img>
                    <span class="d-block d-md-none text-center text-md-left mt-3">{{ item.name }}</span>
                  </td>
                  <td class="d-none d-md-table-cell">
                    <span class="d-none d-md-block">{{ item.name }}</span>
                  </td>

                  <td class="text-center text-md-left">
                    <template v-if="descuento != null">
                      <span
                        class="d-block"
                        style="text-decoration: line-through;"
                      >${{ item.precio }} MX</span>

                      <span>${{ aplicar_descuento(item.precio) }} MX</span>
                    </template>
                    <template v-else>
                      <span>${{ item.precio }} MX</span>
                    </template>
                  </td>
                  <td class="text-center">
                    <span @click="removeFromWishlist(item)" style="cursor:pointer;">
                      <v-icon>mdi-close</v-icon>Eliminar
                    </span>
                  </td>
                  <!-- <td>{{ item.producto.precio * item.cantidad}}</td> -->
                </tr>
                
              </tbody>
            </template>
          </v-simple-table>

        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-right">
          <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#E4CFA6"
                v-bind="attrs"
                v-on="on"
                rounded
                elevation="0"
              >
                Guardar y compartir
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Wishlist de {{nombre}}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field label="Nombre" required v-model="nombre"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
                <v-btn color="blue darken-1" text @click="dialog = false; guardarWishlist();">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      items: [
        {
          text: "Inicio",
          disabled: false,
          href: "/"
        },
        {
          text: "Wishlist",
          disabled: true
        }
      ],
      nombre: '',
      productos: []
    };
  },
  beforeMount: function() {
    this.productos = this.$session.get("wishlist");
  },
  methods: {
    inWishlist(producto) {
      var isIn = false;
      for (let item = 0; item < this.wl.length; item++) {
        if (producto._id == this.wl[item]._id) {
          isIn = true;
        }
      }

      return isIn;
    },
    removeFromWishlist: function(producto) {
      var wishlist = this.$session.get("wishlist");
      var wishlist_auxiliar = [];
      for (let item = 0; item < wishlist.length; item++) {
        if (producto._id != wishlist[item]._id) {
          wishlist_auxiliar.push(wishlist[item]);
        }
      }

      this.$session.set("wishlist", wishlist_auxiliar);
      this.productos = this.$session.get('wishlist');
    },
    addToWishlist(producto) {
      var wishlist = this.$session.get("wishlist");

      wishlist.push(producto);

      this.$session.set("wishlist", wishlist);

      this.productos = this.$session.get('wishlist');
    },
    guardarWishlist(){
      var aux = this;
      var arrayWishlist = [];
      for (let index = 0; index < this.productos.length; index++) {
        var object = {
          "_id": this.productos[index]._id,
          "link": "Productos",
          "display": this.productos[index]._id
        }

        arrayWishlist.push(object);
      }

      fetch('https://flordeazaharcms.actstudio.xyz/api/collections/save/Wishlist?token=bd38a532024ddfd195a5fdefd8eb98', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              data: {
                "productos": arrayWishlist,
                "nombre": this.nombre
              }
          })
        })
        .then(res=>res.json())
        .then(function(entry){
          aux.$router.push("/wishlist/"+entry._id);
        });
      }
  }
};
</script>